import React from 'react';
import { useTranslation } from 'react-i18next';

import { clsx } from '../../utils/utils';
import * as styles from './PriceTag.module.scss';

export interface PriceTagProps {
  price: string;
  className?: string;
}

const PriceTag = ({ price, className }: PriceTagProps): React.ReactElement => {
  const { t, i18n } = useTranslation();
  return (
    <div className={clsx(styles.priceTag, className)}>
      {t('experience_card.price_from', 'From')}
      <em> {Math.floor(parseFloat(price))}€</em>
    </div>
  );
};

export default PriceTag;
